export enum PromoCodeDiscountType {
  Dollar = 0,
  Percent = 1,
}
